import { useMemo } from "react";
import { graphql } from "react-relay";
import { useSubscriptionWithSkip } from "../utils/useSubscriptionWithSkip";

import { useNoteSubscriptionsSubscription } from "./__generated__/useNoteSubscriptionsSubscription.graphql";
import { useNoteSubscriptionsPageSubscription } from "./__generated__/useNoteSubscriptionsPageSubscription.graphql";

export function useNoteSubscriptions(noteId: string, skip = false) {
  useSubscriptionWithSkip<useNoteSubscriptionsPageSubscription>(
    useMemo(
      () => ({
        subscription: graphql`
          subscription useNoteSubscriptionsPageSubscription($noteId: ID!) {
            notePageUpdated(noteId: $noteId) {
              ...WidgetNotePage_widgetNotePage
            }
          }
        `,
        variables: { noteId },
      }),
      [noteId]
    ),
    {
      skip,
    }
  );

  useSubscriptionWithSkip<useNoteSubscriptionsSubscription>(
    useMemo(
      () => ({
        subscription: graphql`
          subscription useNoteSubscriptionsSubscription($noteId: ID!) {
            noteUpdated(noteId: $noteId) {
              ...NoteWeb_note
              ...NoteNative_note
            }
          }
        `,
        variables: { noteId },
      }),
      [noteId]
    ),
    {
      skip,
    }
  );
}
